import {
  SET_LOADING,
  SET_NETWORKS,
  ADD_NETWORKS,
  EDIT_NETWORKS,
  DELETE_NETWORK,
} from '../actions/networks';

export default (
  state = {
    networks: [],
    loading: null,
  },
  { type, data }
) => {
  switch (type) {
    case SET_LOADING:
      return { ...state, loading: data };
    case SET_NETWORKS:
      return { ...state, networks: [...state.networks,...data] };
    case EDIT_NETWORKS:
      const networks = state.networks.map((network) => {
        if (network.id === data.id) {
          return data;
        } else {
          return network;
        }
      });
      return { ...state, networks };

    case DELETE_NETWORK:
      const networksFiltered = state.networks.filter((network) => {
        return network.id !== data.id;
      });
      return { ...state, networks: networksFiltered };

    case ADD_NETWORKS:
      return { ...state, networks: [...state.networks, data] };
    default:
      return state;
  }
};
